module.exports = __webpack_public_path__ + "img/bm_inact.8f056324.svg";